let _previousLocationWasExternal = true;

export const setPreviousLocationInternal = () => {
  _previousLocationWasExternal = false;
};

export const previousLocationWasExternal = () => _previousLocationWasExternal;
